import * as types from '../types/authTypes';
import * as authServices from '../../services/authServices';

const persistAuth = (token, user) => {
  window.localStorage.setItem('CiteMatchToken', token);
  window.localStorage.setItem('CiteMatchUser', JSON.stringify(user));
};

const clearPersistedAuth = () => {
  window.localStorage.removeItem('CiteMatchToken');
  window.localStorage.removeItem('CiteMatchUser');
};

export const login = (data) => async (dispatch) => {
  dispatch({ type: types.AUTH_REQUEST });
  try {
    const response = await authServices.login(data);
    persistAuth(response.token, response.user);
    dispatch({ type: types.AUTH_SUCCESS, payload: { token: response.token, user: response.user } });
    return { success: true, data: response };
  } catch (error) {
    const message = error.response?.data?.message || error.message || 'Login failed';
    dispatch({ type: types.AUTH_FAILURE, payload: message });
    return { success: false, message };
  }
};

export const register = (data) => async (dispatch) => {
  dispatch({ type: types.AUTH_REQUEST });
  try {
    const response = await authServices.register(data);
    persistAuth(response.token, response.user);
    dispatch({ type: types.AUTH_SUCCESS, payload: { token: response.token, user: response.user } });
    return { success: true, data: response };
  } catch (error) {
    const message = error.response?.data?.message || error.message || 'Registration failed';
    dispatch({ type: types.AUTH_FAILURE, payload: message });
    return { success: false, message };
  }
};

export const forgotPassword = (data) => async (dispatch) => {
  dispatch({ type: types.FORGOT_PASSWORD_REQUEST });
  try {
    const response = await authServices.forgotPassword(data);
    dispatch({ type: types.FORGOT_PASSWORD_SUCCESS, payload: response.message || 'Reset link sent' });
    return { success: true, data: response };
  } catch (error) {
    const message = error.response?.data?.message || error.message || 'Reset request failed';
    dispatch({ type: types.FORGOT_PASSWORD_FAILURE, payload: message });
    return { success: false, message };
  }
};

export const logout = () => {
  clearPersistedAuth();
  return { type: types.AUTH_LOGOUT };
};

